<script>
import { ScModal, ScModalCard, ScSpinner } from '@intelipost-js/secure-components';

export default {
  name: 'BillingLoadingModal',
  props: {
    text: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  components: { ScModal, ScModalCard, ScSpinner },
};
</script>

<template>
  <sc-modal :active="isActive" :can-cancel="false">
    <sc-modal-card>
      <template slot="body">
        <section class="modal-content">
          <sc-spinner />
          <p>{{ text }}</p>
        </section>
      </template>
    </sc-modal-card>
  </sc-modal>
</template>

<style scoped lang="scss">
.modal-card {
  border-radius: 16px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .spinner {
    margin-bottom: 20px;
  }

}
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/components/billing-loading-modal/BillingLoadingModal.vue